import { useEffect } from 'react'
import { StatisticItem } from './StatisticItem'
import styles from './StatisticView.module.css'
import { useAppDispatch, useAppSelector } from '../../../../hooks/redux'
import { getStatisticMain } from '../../../../store/statistic-slice/StatisticSlice'
import runImg from './image/bg_run.png'
import bicycleImg from './image/bg_bicycle.png'
import swimmingImg from './image/bg_swimming.png'
import skiImg from './image/bg_ski.png'
import walkImg from './image/bg_walk.png'
import { IcRun } from '../../../../components/ActivityBar/images/IcRun';
import { IcBicycle } from '../../../../components/ActivityBar/images/icBicycle';
import { IcSki } from '../../../../components/ActivityBar/images/IcSki';
import { IcSwimming } from '../../../../components/ActivityBar/images/IcSwimming';
import { IcWalk } from '../../../../components/ActivityBar/images/icWalk';
import { IcSwimming185 } from '../../../../components/ActivityBar/images/icSwimming185';
import { StatisticItemMain } from './StatisticItemMain'
import { TextGradient } from '../../../../components/textGradient/TextGradient'
import { ActivityType, StatisticTrainingCommonDomain } from '../../../../models/commonModels'
export const StatisticView = () =>{
    const dispatch:any = useAppDispatch()
    const data:StatisticTrainingCommonDomain|null = useAppSelector(state=>state.statisticStore.data)
    const token = useAppSelector(state=>state.appStore.token)
    const isAuth = useAppSelector(state=>state.statisticStore.isAuth)
    useEffect(()=>{
        debugger
        dispatch(getStatisticMain())
    },[token])

    const getDistanceImage = () =>{
        switch(data?.top.activity){
            case ActivityType.RUN: 
                return <IcRun color='green'/> 
                break;
            case ActivityType.SKIS: 
                return <IcSki color='green'/> 
                break;
             case ActivityType.BICYCLE: 
                return <IcBicycle color='green'/> 
                break;        
            case ActivityType.SWIMMING: case ActivityType.SWIMMING_185:
                return <IcSwimming color='green'/> 
                break;  
            case ActivityType.WALK: 
                return <IcWalk color='green'/> 
                break;
            default:
                return <div></div>
            }
        
    }
    return (
        <div style={{marginTop:"20px"}}>
            <div className={styles.statisticView_line}></div>
            <div>
                <div style={{fontSize:"20px", fontWeight:"700", textAlign:"center", marginBottom:"10px"}}>СТАТИСТИКА СЕГОДНЯ</div>
                    <TextGradient
                        colors={["#739E72","#1C6A93","#F65B3E"]}
                        // text={mainData.distance_length.toLocaleString('ru-RU')}
                        text= {data?data.distance.toLocaleString('ru'):"0"}
                        fontSize={"20px"}
                        fontWeigth={"700"}/>
                    <TextGradient
                        colors={["#739E72","#1C6A93","#F65B3E"]}
                        text={"общий результат, км"}
                        fontSize={"14px"}
                        fontWeigth={"400"}/>
                        <div className={styles.statisticView_container}>
                            {isAuth==true&&<div className={styles.statisticView_card_container}>
                                <StatisticItem bgImage={runImg} activity='RUN' />
                                <StatisticItem bgImage={bicycleImg}  activity='BICYCLE'/>
                                <StatisticItem bgImage={swimmingImg} activity='SWIMMING'/>
                                <StatisticItem bgImage={skiImg} activity='SKIS'/>
                                <StatisticItem bgImage={walkImg} activity='WALK'/>
                                <StatisticItemMain activityImg={getDistanceImage()} 
                                    name={data!=null?data.top.name:"- -"} 
                                    distance={data!=null?data.top.distance.toLocaleString('ru'):"0"}
                                    activity={data!=null?data.top.activity:""}
                                    />
                            </div>}
                        </div>
                </div>
        </div>
        
        
    )
}